/**
 * Unique identifier for the DealsApi feature group.
 */
export const DEALS_API_FEATURE_GROUP_ID = "DEALS_API_FEATURE_GROUP";
